import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './App';
import store from './store';
import { setUser } from './store/chatSlice';

fetch('/api/me')
  .then((r) => (r.ok ? r.json() : { display_name: 'Unknown' }))
  .then((user) => store.dispatch(setUser(user)))
  .catch((e) => console.warn('Failed to fetch /api/me:', e));

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>
);